import React, { createContext, useContext, useState, useEffect } from 'react'
import { setLanguage, getCurrentLanguage, getAvailableLanguages } from '../utils/textManager'

const LanguageContext = createContext()

export const useLanguage = () => {
  const context = useContext(LanguageContext)
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider')
  }
  return context
}

export const LanguageProvider = ({ children }) => {
  const [currentLanguage, setCurrentLanguage] = useState('zh')
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    // 从localStorage恢复语言设置
    const storedLanguage = localStorage.getItem('selectedLanguage')
    if (storedLanguage && getAvailableLanguages().includes(storedLanguage)) {
      setLanguage(storedLanguage)
      setCurrentLanguage(storedLanguage)
    } else {
      setCurrentLanguage(getCurrentLanguage())
    }
  }, [])

  const changeLanguage = (language) => {
    if (getAvailableLanguages().includes(language)) {
      setIsLoading(true)
      setLanguage(language)
      setCurrentLanguage(language)
      localStorage.setItem('selectedLanguage', language)
      
      // 添加轻微延迟以提供视觉反馈
      setTimeout(() => {
        setIsLoading(false)
        // 触发全局重新渲染事件
        window.dispatchEvent(new CustomEvent('languageChanged', { detail: language }))
      }, 200)
    }
  }

  const value = {
    currentLanguage,
    changeLanguage,
    isLoading,
    availableLanguages: getAvailableLanguages()
  }

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  )
}

export default LanguageContext